export default {
    methods: {
      setTitle(title) {
        document.title = title ? `${title} - কথাপ্রকাশ` : 'কথাপ্রকাশ | সৃজনের আনন্দে পথচলা';
      }
    },
    created() {
      if (this.$options.title) {
        this.setTitle(this.$options.title);
      }
    }
  };